
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";

  @Component({
    name: 'slz-dialog',
  })
  export default class SlzDialog extends Vue {
    @Prop({
      default: '388px'
    }) private width!: string;
    @Prop({
      default: false
    }) private showmask!: boolean;
    @Prop({
      default:false
    }) private loading:boolean
    @Prop({
      default: '标题'
    }) private title!: string;
    @Model('change') isShow!: boolean;

    @Watch('isShow')
    private onChangeShow(val: any) {
      if (val) {
        this.$emit('open')
      }
    }

    private handleClick(e: any) {

    }

    private handleClose() {
      this.$emit('change', false)
      this.$emit('close')
    }
  }
